import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCalculatedCropFootprintByCropIdAndYear, getCalculatedCropFootprintByCropIdAndYearAdmin } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_CROP_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedCropFootprints = (farmId?: string, years: number[] = [], cropIds: string[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  const allYearCropIdCombos = years.flatMap((year) => cropIds.map((cropId) => ({ year, cropId })));

  return useQueries({
    queries: allYearCropIdCombos.map(({ year, cropId }) => ({
      queryKey: [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, farmId, cropId, year, isAdmin],
      queryFn: () =>
        isAdmin
          ? getCalculatedCropFootprintByCropIdAndYearAdmin(farmId ?? "", year, cropId)
          : getCalculatedCropFootprintByCropIdAndYear(farmId ?? "", year, cropId),
      enabled: enabled && !!farmId && !!cropId && !!year && isLoggedIn && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      queryClient,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    })),
  });
};
